// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__4GX6h","title":"ClientInsurance_title__1hdqU","itemText":"ClientInsurance_itemText__2MZSj"};